/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface KakaoAuthControllerKakaoAuthCallbackV1$Params {
}

export function kakaoAuthControllerKakaoAuthCallbackV1(http: HttpClient, rootUrl: string, params?: KakaoAuthControllerKakaoAuthCallbackV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'accessToken'?: string;
'refreshToken'?: string;
}>> {
  const rb = new RequestBuilder(rootUrl, kakaoAuthControllerKakaoAuthCallbackV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'accessToken'?: string;
      'refreshToken'?: string;
      }>;
    })
  );
}

kakaoAuthControllerKakaoAuthCallbackV1.PATH = '/api/v1/oauth/kakao/callback';
